import(/* webpackMode: "eager" */ "/opt/bitnami/apache/htdocs/apps/voh-main-next/src/components/Updates/OneUp/index.tsx")